"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PretestInviteSummaryDtoToJSON = exports.PretestInviteSummaryDtoFromJSONTyped = exports.PretestInviteSummaryDtoFromJSON = exports.instanceOfPretestInviteSummaryDto = exports.PretestInviteSummaryDtoInviteStatusEnum = void 0;
var runtime_1 = require("../runtime");
var PatientWorkListOutcomeDto_1 = require("./PatientWorkListOutcomeDto");
var PretestInviteDocumentDto_1 = require("./PretestInviteDocumentDto");
/**
 * @export
 */
exports.PretestInviteSummaryDtoInviteStatusEnum = {
    Scheduled: 'scheduled',
    Created: 'created',
    Sent: 'sent',
    Opened: 'opened',
    Completed: 'completed',
    Resent: 'resent',
    Expired: 'expired',
    MissingContactInfo: 'missing_contact_info',
    LockedByProvider: 'locked_by_provider',
    LockedByVerifyUserFail: 'locked_by_verify_user_fail',
    PendingSend: 'pending_send'
};
/**
 * Check if a given object implements the PretestInviteSummaryDto interface.
 */
function instanceOfPretestInviteSummaryDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPretestInviteSummaryDto = instanceOfPretestInviteSummaryDto;
function PretestInviteSummaryDtoFromJSON(json) {
    return PretestInviteSummaryDtoFromJSONTyped(json, false);
}
exports.PretestInviteSummaryDtoFromJSON = PretestInviteSummaryDtoFromJSON;
function PretestInviteSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inviteStatus': !(0, runtime_1.exists)(json, 'inviteStatus') ? undefined : json['inviteStatus'],
        'dateAppointmentPretest': !(0, runtime_1.exists)(json, 'dateAppointmentPretest') ? undefined : json['dateAppointmentPretest'],
        'inviteId': !(0, runtime_1.exists)(json, 'inviteId') ? undefined : json['inviteId'],
        'report': !(0, runtime_1.exists)(json, 'report') ? undefined : (0, PretestInviteDocumentDto_1.PretestInviteDocumentDtoFromJSON)(json['report']),
        'transcript': !(0, runtime_1.exists)(json, 'transcript') ? undefined : (0, PretestInviteDocumentDto_1.PretestInviteDocumentDtoFromJSON)(json['transcript']),
        'invites': !(0, runtime_1.exists)(json, 'invites') ? undefined : json['invites'],
        'workListOutcomes': !(0, runtime_1.exists)(json, 'workListOutcomes') ? undefined : (0, PatientWorkListOutcomeDto_1.PatientWorkListOutcomeDtoFromJSON)(json['workListOutcomes']),
    };
}
exports.PretestInviteSummaryDtoFromJSONTyped = PretestInviteSummaryDtoFromJSONTyped;
function PretestInviteSummaryDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'inviteStatus': value.inviteStatus,
        'dateAppointmentPretest': value.dateAppointmentPretest,
        'inviteId': value.inviteId,
        'report': (0, PretestInviteDocumentDto_1.PretestInviteDocumentDtoToJSON)(value.report),
        'transcript': (0, PretestInviteDocumentDto_1.PretestInviteDocumentDtoToJSON)(value.transcript),
        'invites': value.invites,
        'workListOutcomes': (0, PatientWorkListOutcomeDto_1.PatientWorkListOutcomeDtoToJSON)(value.workListOutcomes),
    };
}
exports.PretestInviteSummaryDtoToJSON = PretestInviteSummaryDtoToJSON;
